import { Card } from "@mantine/core";
import React, { useEffect } from "react";
import { JobListing as JobType } from "@lib/types/jobTypes";
import ErrorBoundary from "../Various/ErrorBoundary";
import SectionHeading from "../Various/SectionHeading";
import AtAGlace from "./AtAGlace";
import GeneralInformation from "./GeneralInformation";
import StructuredData from "./StructuredData";
import { sendJobView } from "@lib/actions/job/sendJobView";
import { trackEvent } from "@components/Various/Analytics/gtag";
import { useTranslation } from "next-i18next";

import JobDescriptions from "./JobDescriptions";
import CompactCompanyListing from "./CompactCompanyListing";
import SendApplication from "./SendApplication/SendApplication";
import JobRecommendations from "./JobRecommendations/JobRecommendations";

function JobListing({
  job,
  hideActions,
  hideCompany,
  afterJobElement,
}: {
  job: JobType;
  hideActions?: boolean;
  hideCompany?: boolean;
  afterJobElement?: React.ReactNode;
}) {
  const { t } = useTranslation("joblisting");
  const [isSendApplicationOpen, setIsSendApplicationOpen] =
    React.useState(false);

  useEffect(() => {
    sendJobView(job.id);

    trackEvent({
      action: "view_job",
      category: "job",
      label: job.id,
    });
  }, [job.id]);

  const hasCustomApplicationLink =
    job.custom_application_link && job.custom_application_link.length > 0;

  return (
    <div className="flex justify-center" data-test="job-listing">
      <div className="w-full md:max-w-4xl px-6 lg:px-0">
        <Card withBorder radius="md" px="xl" mb="lg">
          {/* {job.job_address?.city && <SplashImage city={job.job_address.city} />} */}

          <ErrorBoundary>
            <GeneralInformation
              job={job}
              sendApplication={() => {
                trackEvent({
                  action: "open_application_modal",
                  category: "job",
                  label: job.id,
                });

                if (hasCustomApplicationLink) {
                  window.open(job.custom_application_link!, "_blank");
                } else {
                  setIsSendApplicationOpen(true);
                }
              }}
              hasCustomApplicationLink={!!hasCustomApplicationLink}
              hideActions={hideActions}
            />
          </ErrorBoundary>

          <ErrorBoundary>
            <AtAGlace job={job} />
          </ErrorBoundary>

          <ErrorBoundary>
            <JobDescriptions job={job} />
          </ErrorBoundary>
        </Card>
        {!hideCompany && (
          <>
            <SectionHeading>{t("about-the-company")}</SectionHeading>
            <ErrorBoundary>
              <CompactCompanyListing company={job.company} />
            </ErrorBoundary>
          </>
        )}
        <ErrorBoundary>
          {job.id && job.recommendable && <JobRecommendations job={job} />}
        </ErrorBoundary>
        <SendApplication
          jobId={job.id}
          isOpen={isSendApplicationOpen}
          close={() => {
            setIsSendApplicationOpen(false);
            trackEvent({
              action: "close_application_modal",
              category: "job",
              label: job.id,
            });
          }}
        />
        <ErrorBoundary>
          <StructuredData job={job} />
        </ErrorBoundary>

        {afterJobElement}
      </div>
    </div>
  );
}

export default JobListing;
